<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <a class="navbar-brand" href="\">
    <img src="assets/img/favicon.png" height="50" alt="TetrisNumerico">  TetrisNumerico
  </a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarColor01"
    aria-controls="navbarColor01"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarColor01">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" routerLink="/">Home</a>
      </li>
      <li class="nav-item active">
        <a class="nav-link" routerLink="/tops">Tops</a>
      </li>
      
      <span class="fill-space"></span>


      <li class="nav-item active" *ngIf="user$ | async as user">
      </li>
    </ul>
    <ul class="navbar-nav mx-auto" *ngIf="user$ | async as user; else login">
      <li class="nav-item" *ngIf="user">
        <a href="#" class="nav-link" (click)="onLogout()">Logout</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"> {{ user?.email }}</a>
      </li>
    </ul>

    <span class="fill-space"></span>

    <ng-template #login>
      <ul class="navbar-nav mx-auto">
        <li class="nav-item">
          <a class="nav-link" routerLink="/login">Login</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/register">Register</a>
        </li>


        

      </ul>
    </ng-template>
  </div>
</nav>


